import {
  SnapCourse,
  SnapCourseCreateInput,
  SnapCourseIdInput,
  SnapCourseUpdateInput
} from "../../../../types/gqlTypes/graphql"
import {
  CREATE_SNAPCOURSE,
  DELETE_SNAPCOURSE,
  UPDATE_SNAPCOURSE
} from "./snapCourseMutations"

import { executeMutationSideload } from "../../../generic-services/helpers/studyPlan"

export async function createSnapCourse(
  data: SnapCourseCreateInput
): Promise<SnapCourse> {
  const response = await executeMutationSideload(CREATE_SNAPCOURSE, {
    data
  })
  return response.content_createSnapCourse
}

export async function updateSnapCourse(
  data: SnapCourseUpdateInput
): Promise<SnapCourse> {
  const response = await executeMutationSideload(UPDATE_SNAPCOURSE, {
    data
  })
  return response.content_updateSnapCourse
}

export async function deleteSnapCourse(
  data: SnapCourseIdInput
): Promise<boolean> {
  const response = await executeMutationSideload(DELETE_SNAPCOURSE, {
    data
  })
  return response.content_deleteSnapCourse
}
